import { render, staticRenderFns } from "./S12UiFixed.vue?vue&type=template&id=b165c672&scoped=true&"
import script from "./S12UiFixed.vue?vue&type=script&lang=js&"
export * from "./S12UiFixed.vue?vue&type=script&lang=js&"
import style0 from "./S12UiFixed.vue?vue&type=style&index=0&id=b165c672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b165c672",
  null
  
)

export default component.exports